"use client";

import { c as _c } from "react/compiler-runtime";
import { CommentsGuidelines } from "@/components/Comment/components/prompts/CommentGuidelines.component";
import { useComments } from "@/components/Comment/context/comments.context";
import { Translation } from "@/components/Translation/Translation.component";
export function CommentsHeader() {
  const $ = _c(9);
  const {
    state: t0
  } = useComments();
  const {
    totalComments
  } = t0;
  const t1 = `Deltag i samtalen (${totalComments})`;
  const t2 = `Nehmen Sie an der Diskussion teil (${totalComments})`;
  const t3 = `Join the conversation (${totalComments})`;
  const t4 = `Bli med i samtalen (${totalComments})`;
  const t5 = `Delta i samtalet (${totalComments})`;
  let t6;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = <h2 className="font-theme-bold text-black text-lg uppercase"><Translation da={t1} de={t2} en={t3} no={t4} sv={t5} /></h2>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CommentsGuidelines />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6) {
    t8 = <header className="mb-4">{t6}{t7}</header>;
    $[7] = t6;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}